import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { getStoredTheme, resolveTheme, setTheme, watchSystemTheme } from '../lib/theme.js';

const LABEL: Record<'light' | 'dark', string> = {
  light: 'Light theme',
  dark: 'Dark theme',
};

export function ThemeToggle({ className }: { className?: string }) {
  const [effective, setEffective] = useState<'light' | 'dark'>(() =>
    resolveTheme(getStoredTheme()),
  );

  useEffect(() => {
    // Resyncs the icon if the OS preference changes while no explicit choice has been made
    // yet — the document repaints itself; this just keeps the button's own icon truthful.
    return watchSystemTheme(() => setEffective(resolveTheme(getStoredTheme())));
  }, []);

  const next: 'light' | 'dark' = effective === 'dark' ? 'light' : 'dark';
  const Icon = effective === 'dark' ? Moon : Sun;

  return (
    <button
      type="button"
      onClick={() => {
        setTheme(next);
        setEffective(next);
      }}
      aria-label={`Theme: ${LABEL[effective]}. Click to switch to ${LABEL[next].toLowerCase()}.`}
      title={LABEL[effective]}
      className={
        className ??
        'flex size-10 shrink-0 items-center justify-center rounded-full bg-bg-subtle sm:size-9 text-fg-muted transition-colors hover:text-fg'
      }
    >
      <Icon className="size-4" />
    </button>
  );
}
